export default __webpack_public_path__ + "static/media/1-gram-generic-gold-bar-999-fine-ira-approved-secondary-market--132084752010858862.d56da619.jpg";